module.exports = __webpack_public_path__ + "marriott-mockup@2x.1sQWim7E.png";